<!-- Apple-style Hero Header -->
 <app-page-header
  title="Kundenregistrierungen"
  subtitle="Verwaltung aller Kundenregistrierungen - Freischalten, Ablehnen und Verwalten von Kundenkonten."
  icon="manage_accounts"
  variant="gradient">
</app-page-header>

<div class="apple-container pending-customers-container apple-slide-up">
  <mat-card class="apple-card filter-card">
    <mat-card-content>
      <!-- Filter Section -->
      <div class="filter-section">
        <mat-form-field appearance="outline" class="filter-field">
          <mat-label>Status</mat-label>
          <mat-select [(ngModel)]="filterStatus" (ngModelChange)="applyFilters()">
            <mat-option value="All">Alle</mat-option>
            <mat-option value="Pending">Ausstehend</mat-option>
            <mat-option value="Unlocked">Freigeschaltet</mat-option>
            <mat-option value="Rejected">Abgelehnt</mat-option>
            <mat-option value="Deactivated">Deaktiviert</mat-option>
          </mat-select>
          <mat-icon matPrefix>filter_list</mat-icon>
        </mat-form-field>

        <mat-form-field appearance="outline" class="filter-field">
          <mat-label>Suche (E-Mail oder Name)</mat-label>
          <input matInput [(ngModel)]="searchText" (ngModelChange)="applyFilters()" placeholder="Suchen...">
          <mat-icon matPrefix>search</mat-icon>
        </mat-form-field>

        <mat-form-field appearance="outline" class="filter-field">
          <mat-label>Kundennummer</mat-label>
          <input matInput [(ngModel)]="filterCustomerNo" (ngModelChange)="applyFilters()" placeholder="20808">
          <mat-icon matPrefix>tag</mat-icon>
        </mat-form-field>

        <button mat-raised-button (click)="clearFilters()" 
        style="align-self: start; margin-top: 5px;">
          <mat-icon>clear_all</mat-icon>
          Filter zurücksetzen
        </button>

        <span class="result-count">{{ filteredCustomers.length }} von {{ allCustomers.length }} Kunden</span>
      </div>
    </mat-card-content>
  </mat-card>

  @if (allCustomers.length === 0) {
    <mat-card class="empty-state" style="width: auto;">
      <mat-icon class="empty-icon">people</mat-icon>
      <h3>Keine Kundenregistrierungen</h3>
      <p>Es wurden noch keine Kunden registriert.</p>
    </mat-card>
  } @else {
    <!-- Bulk Actions Bar -->
    @if (selection.selected.length > 0) {
      <mat-card class="bulk-actions-bar">
        <div class="bulk-actions-content">
          <span class="selection-count">{{ selection.selected.length }} Kunden ausgewählt</span>
          <div class="bulk-buttons">
            <button mat-raised-button color="primary" (click)="approveBulk()">
              <mat-icon>check_circle</mat-icon>
              Ausgewählte freischalten
            </button>
            <button mat-raised-button color="warn" (click)="rejectBulk()">
              <mat-icon>cancel</mat-icon>
              Ausgewählte ablehnen
            </button>
            <button mat-button (click)="selection.clear()">
              <mat-icon>clear</mat-icon>
              Auswahl aufheben
            </button>
          </div>
        </div>
      </mat-card>
    }

    <mat-card class="table-card">
      <table mat-table [dataSource]="filteredCustomers" class="pending-table">

        <!-- Checkbox Column -->
        <ng-container matColumnDef="select">
          <th mat-header-cell *matHeaderCellDef>
            <mat-checkbox (change)="$event ? toggleAllRows() : null"
                          [checked]="selection.hasValue() && isAllSelected()"
                          [indeterminate]="selection.hasValue() && !isAllSelected()"
                          [aria-label]="checkboxLabel()">
            </mat-checkbox>
          </th>
          <td mat-cell *matCellDef="let customer">
            <mat-checkbox (click)="$event.stopPropagation()"
                          (change)="$event ? selection.toggle(customer) : null"
                          [checked]="selection.isSelected(customer)"
                          [aria-label]="checkboxLabel(customer)"
                          [disabled]="customer.registrationStatus !== 'Pending'">
            </mat-checkbox>
          </td>
        </ng-container>

        <!-- Customer Number Column -->
        <ng-container matColumnDef="customerNo">
          <th mat-header-cell *matHeaderCellDef>Kundennummer</th>
          <td mat-cell *matCellDef="let customer">
            <strong>{{ customer.reflexCustomerNo || 'N/A' }}</strong>
          </td>
        </ng-container>

        <!-- Email Column -->
        <ng-container matColumnDef="email">
          <th mat-header-cell *matHeaderCellDef>E-Mail</th>
          <td mat-cell *matCellDef="let customer">
            {{ customer.userDetails?.email || 'N/A' }}
          </td>
        </ng-container>

        <!-- Name Column -->
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef>Name</th>
          <td mat-cell *matCellDef="let customer">
            {{ customer.userDetails?.firstName || customer.userDetails?.lastName ?
               (customer.userDetails?.firstName || '') + ' ' + (customer.userDetails?.lastName || '') : 'N/A' }}
          </td>
        </ng-container>

        <!-- Registration Date Column -->
        <ng-container matColumnDef="registrationDate">
          <th mat-header-cell *matHeaderCellDef>Registriert am</th>
          <td mat-cell *matCellDef="let customer">
            {{ customer.userDetails?.createdDate ? (customer.userDetails.createdDate | date:'dd.MM.yyyy HH:mm') : 'N/A' }}
          </td>
        </ng-container>

        <!-- Status Column -->
        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef>Status</th>
          <td mat-cell *matCellDef="let customer">
            <mat-chip [color]="getStatusColor(customer.registrationStatus)">
              <mat-icon>{{ customer.registrationStatus === 'Pending' ? 'schedule' : 'info' }}</mat-icon>
              {{ getStatusLabel(customer.registrationStatus) }}
            </mat-chip>
          </td>
        </ng-container>

        <!-- Actions Column -->
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef>Aktionen</th>
          <td mat-cell *matCellDef="let customer">
            <div class="action-buttons">
              <button
                mat-raised-button
                color="primary"
                (click)="approveCustomer(customer)"
                [disabled]="customer.registrationStatus !== 'Pending'">
                <mat-icon>check_circle</mat-icon>
                Freischalten
              </button>
              <button
                mat-raised-button
                color="warn"
                (click)="rejectCustomer(customer)"
                [disabled]="customer.registrationStatus !== 'Pending'">
                <mat-icon>cancel</mat-icon>
                Ablehnen
              </button>
              <button
                mat-raised-button
                color="primary"
                (click)="activateCustomer(customer)"
                [disabled]="!customer.azureObjectId || customer.registrationStatus === 'Unlocked'"
                matTooltip="Aktiviert das Konto in Entra ID">
                <mat-icon>check_circle</mat-icon>
                Aktivieren
              </button>
              <button
                mat-raised-button
                color="accent"
                (click)="deactivateCustomer(customer)"
                [disabled]="!customer.azureObjectId || customer.registrationStatus === 'Deactivated'"
                matTooltip="Deaktiviert das Konto in Entra ID">
                <mat-icon>block</mat-icon>
                Deaktivieren
              </button>
              <button
                mat-raised-button
                (click)="deleteCustomer(customer)"
                [disabled]="!customer.azureObjectId"
                matTooltip="Löscht das Entra ID Konto und markiert den Kunden als gelöscht"
                style="background-color: #d32f2f; color: white;">
                <mat-icon>delete_forever</mat-icon>
                Löschen
              </button>
              <button
                mat-icon-button
                color="primary"
                (click)="resendApprovalEmail(customer)"
                [disabled]="customer.registrationStatus !== 'Unlocked' && customer.accountState !== 'Enabled'"
                matTooltip="Freischaltungs-E-Mail erneut senden">
                <mat-icon>mail</mat-icon>
              </button>
              <button
                mat-icon-button
                color="accent"
                (click)="viewCustomerDetails(customer)"
                matTooltip="Details anzeigen">
                <mat-icon>open_in_new</mat-icon>
              </button>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="customer-row"></tr>
      </table>
    </mat-card>
  }
</div>
